module.exports = __webpack_public_path__ + "static/media/hostsearch-logo.48b59bc8.png";